import * as React from 'react';

import {Button} from 'shells/button/button';
// @ts-expect-error - imported from .js/.jsx file
import {DownloadIcon} from 'shells/icon/svg/download-icon';
import {FileUploadIcon} from 'shells/icon/svg/file-upload-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import {useCreateProductsCsv} from './graphql/hooks/use-create-products-csv';

export function ProductsPageActionBttns() {
    const {createProductsCsv} = useCreateProductsCsv();

    return (
        <StackLegacy spacing={16} isHorizontal={true}>
            <Button
                variant='primary'
                size='big'
                icon={(props) => <FileUploadIcon {...props} />}
                onClick={() => {
                    window.open('/setup/import/products');
                }}
            >
                Import
            </Button>
            <Button
                variant='primary'
                size='big'
                icon={DownloadIcon}
                onClick={() => {
                    createProductsCsv().then(({data}) => {
                        if (data && data.productsExport) {
                            window.open(data.productsExport.url, '_blank');
                        }
                    });
                }}
            >
                Export
            </Button>
        </StackLegacy>
    );
}
